import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import {
  FaHistory,
  FaChartBar,
  FaSignOutAlt,
  FaSignInAlt,
  FaUserEdit,
} from "react-icons/fa";
import "../styles/application-header.css";

const LOGIN_URL = "https://pisio-app.duckdns.org/oauth2/authorization/google";

const ApplicationHeader = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <header className="app-header">
      <nav className="nav-bar-main">
        <span>
          <Link to="/">
            <span className="logo-title">
              <img src="logo192.png" alt="Logo" className="logo" />
              incident <span className="logo-title-2">app</span>
            </span>
          </Link>
        </span>

        {user?.role === "USER" && (
          <span>
            <Link to="/past-incidents">
              <FaHistory className="nav-icon" />
            </Link>
          </span>
        )}
        {(user?.role === "ADMIN" || user?.role === "MODERATOR") && (
          <span>
            <Link to="/users">
              <FaUserEdit className="nav-icon" />
            </Link>
          </span>
        )}
        {user?.role === "ADMIN" && (
          <span>
            <Link to="/analytics">
              <FaChartBar className="nav-icon" />
            </Link>
          </span>
        )}
      </nav>

      <nav className="nav-bar-auth">
        {user ? (
          <button onClick={handleLogout}>
            <FaSignOutAlt /> Logout
          </button>
        ) : (
          <a href={LOGIN_URL} className="nav-link">
            <FaSignInAlt className="nav-icon" /> Login
          </a>
        )}
      </nav>
    </header>
  );
};

export default ApplicationHeader;
